import React from 'react';
import './Modal.css';

function Modal({ onClose, className = '', children }) {
  return (
    <div className="cw-modal-overlay" onClick={onClose}>
      <div
        className={`cw-modal${className ? ` ${className}` : ''}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default Modal;
